import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { RiSearch2Line, RiCloseFill } from "react-icons/ri";
import useMobileMenu from "@hooks/useMobileMenu";
import MobileSearchPage from "./search/MobileSearchPage";
import MobileMegaMenuItems from "./MobileMegaMenuItems";
import MobileMenuSlide from "./MobileMenuSlide";
import useNavigate from "@hooks/useNavigate";
const MobileMenu = ({ headerDetails }) => {
    const [isSearchPage, setIsSearchPage] = useState(false);
    const { mobilePages, closeAllPages, addPage, closeLastPage } = useMobileMenu();
    const { navigate } = useNavigate();
    const defaultMobilePage = {
        currentPage: { title: "Home", url: null },
        previousPage: { title: "Home", url: null },
        isOpen: true,
        contact: headerDetails.contact,
        megaMenuItems: headerDetails.megaMenuItems,
        cultures: headerDetails.cultures,
        menuItems: headerDetails.menuItems
    };
    const defaultSearchPage = {
        content: _jsx(MobileSearchPage, {}),
        isOpen: true
    };
    const onSelectPage = (item, previousPage) => {
        var _a;
        if (item)
            if (!(item === null || item === void 0 ? void 0 : item.children) || ((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) < 1) {
                navigate(item.url);
                return;
            }
        addPage(mobilePages, {
            currentPage: { title: item.title, url: item.url },
            title: item.title,
            previousPage: { title: previousPage, url: "#" },
            isOpen: true,
            megaMenuItems: item.children,
            featuredItems: "featured" in item ? item.featured : [],
            titleClassName: "text-base font-bold",
            className: "py-3"
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "header__mobile-menu-header", children: [!isSearchPage && (_jsx(RiSearch2Line, { className: "header__mobile-menu-header-icon", onClick: () => {
                            if (mobilePages.length > 0 && !isSearchPage) {
                                closeAllPages();
                            }
                            setIsSearchPage(true);
                            addPage(mobilePages, defaultSearchPage);
                        } })), mobilePages && mobilePages.length > 0 ? (_jsx(RiCloseFill, { onClick: () => {
                            setIsSearchPage(false);
                            closeAllPages();
                        }, className: "header__mobile-menu-header-icon" })) : (_jsx(RxHamburgerMenu, { onClick: () => {
                            setIsSearchPage(false);
                            addPage(mobilePages, defaultMobilePage);
                        }, className: "header__mobile-menu-header-icon" }))] }), mobilePages &&
                mobilePages.length > 0 &&
                mobilePages.map((mobilePage, i) => (_jsx(MobileMenuSlide, { mobilePage: mobilePage, children: isSearchPage ? mobilePage.content : _jsx(MobileMegaMenuItems, { mobileMenuPage: mobilePage, onSelect: onSelectPage, onCloseLastPage: closeLastPage }) }, i)))] }));
};
export default MobileMenu;
